/**
 * コイン要素を作成しDOMに追加する。アニメーション終わったらDOMから取り去る。
 * @param  {Number} numOfCoins - コイン枚数
 * @param  {String} [color=gold] - 'gold' (金) || 'silver' (銀) || 'bronze' (銅)
 * @returns {Promise} - 最後の枚数が出たらpromiseで通信する
 * @example flipCoin(5);
 */
function flipCoin(numOfCoins, color) {
  numOfCoins = numOfCoins || 1; // 規定は1枚のコイン
  color = color || 'gold';
  var coinPouch = [];

  // 裏か表を表示する
  var flipResult = '720deg'; // 720deg or 900deg
  document.documentElement.style.setProperty('--flips', flipResult);

  // 飛ぶ先のページ内位置を設定(CSSアニメーションで利用する変数)
  var targetElX = $('.global-menu__button--points').length > 0 ? $('.global-menu__button--points').position().left + 'px' : '90vw';
  document.documentElement.style.setProperty('--flip-target-x', targetElX);

  var $coin = '' + // インデントのため次の行で始まる
  '<div class="coin-box anim ' + color + '">' +
    '<div class="floor">' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
      '<div class="line anim"></div>' +
    '</div>' + // .floor
    '<div class="coin anim">' +
      '<div class="edge">' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
        '<div class="segment"></div>' +
      '</div>' + // .edge
    '</div>' + // .coin
  '</div>'; // .coin-box

  // coinPouchという配列（財布）に設定した枚数を入れる
  for (var coinIndex = 0; coinIndex < numOfCoins; coinIndex += 1) {
    coinPouch.push($coin);
  }

  var status = $.Deferred(); // 関数のステータス通信変数を設定する

  $(coinPouch).each(function(index, pouchCoin) {
    // apply animation and wait for completion
    setTimeout(function() {
      $(pouchCoin) // 配列から一つのコインを指定し、
        .appendTo('body') // <body>に追加
          .one('animationend', function() { // アニメーションが終わった後に下記関数を一回だけを実行
            if ($(this).hasClass('coin-box')) { // アニメーションされている要素が多いため親要素だけを指定する
              $(this).fadeOut('fast', function() { // コインをフェイドアウト
                $(this).remove() // コイン要素をDOMから取り去る
                  .promise().done(function() { // DOMから取り去ったら...
                    if (index === numOfCoins - 1) { // 現在のコインがループの最後と一緒
                      status.resolve('すべて終わった！'); // 最後のコインまでできたっという通信を送る
                    }
                  });
              });
            }
          })
    }, 750 * index); // setTimeout
  });

  return status.promise(); // ステータスを送る
}

/**
 * みポイントゲット画面を出して、コインアニメーションを実施
 * @param  {Number} numOfPoints - みポイント数（表示）
 * @param  {Number} numOfCoins - コイン枚数（アニメーション回数）
 * @param  {String} [color=gold] - 'gold' (金) || 'silver' (銀) || 'bronze' (銅)
 * @example pointGetScreen(100, 5);
 */
function pointGetScreen(numOfPoints, numOfCoins, color) {
  numOfPoints = numOfPoints || 0; // コイン枚数の規定は 0
  color = color || '';
  if ($('.point-box').length > 0) return; // 複数の画面を同時に出ないように

  // みポイントゲットの画面のHTMLテンプレート
  var getScreen = '' +
    '<div class="point-box ' + color + '" style="display: none;">' +
      // '<div class="point-box__message">' +
      //   '<strong>み</strong>ポイント<br>ゲット！' + 
      // '</div>' +
      '<div class="point-box__points">' +
        numOfPoints +
      '</div>' +
    '</div>';

  // 上記画面をDOMに追加し、フェイドインを実施
  $(getScreen).appendTo('body').fadeIn('fast');

  // flipCoinが終わったら下記内容を実行する
  // (すべてのコインの出る事が終わったらポイント画面は不要のためフェイドアウトする)
  flipCoin(numOfCoins, color).done(function() {
    $('.point-box').fadeOut('slow', function() {
      $(this).remove(); // メモリーを整理するためDOMから取り去る
    })
  });
}
